module.exports = __webpack_public_path__ + "static/media/FT-FONDO-INSTALACIONES.c64b8115.jpg";